import React from "react";
import { Marker } from "react-naver-maps";
import { ModelGeoCampaign } from "@models/ModelGeoCampaign";
import { useThemeClass } from "@/Hooks/useThemeClass";
import { useTheme } from "styled-components";
import { AppTheme } from "@/themes/types";

interface MapMarkersProps {
  clusterMarkers: ModelGeoCampaign[];
  detailMarkers: ModelGeoCampaign[];
  zoomLevel: number;
  pathname: string;
  onMarkerClick: (marker: ModelGeoCampaign) => void;
  createMarkerOptions: (marker: ModelGeoCampaign) => any;
}

export const MapMarkers: React.FC<MapMarkersProps> = ({
  clusterMarkers,
  detailMarkers,
  zoomLevel,
  pathname,
  onMarkerClick,
  createMarkerOptions,
}) => {
  const themeClass = useThemeClass();
  const theme = useTheme() as AppTheme;

  // Cluster markers (zoom < 12)
  if (zoomLevel < 12 && clusterMarkers.length > 0) {
    return (
      <>
        {clusterMarkers.map((marker) => {
          const markerOptions = createMarkerOptions(marker);
          return (
            <Marker
              key={`cluster-${marker.id}`}
              position={{ lat: marker.latitude, lng: marker.longitude }}
              icon={markerOptions?.icon}
              onClick={() => {
                onMarkerClick(marker);
              }}
              clickable={true}
            />
          );
        })}
      </>
    );
  }

  // Detail markers
  if (
    detailMarkers.length > 0 &&
    typeof window !== "undefined" &&
    window.naver?.maps
  ) {
    return (
      <>
        {detailMarkers.map((marker) => (
          <Marker
            key={`detail-${marker.id}`}
            position={{ lat: marker.latitude, lng: marker.longitude }}
            onClick={() => {
              onMarkerClick(marker);
            }}
            clickable={true}
            icon={{
              content: `
                <div style="
                  width: 24px;
                  height: 24px;
                  background-color: ${theme.colors.text};
                  border-radius: 9999px 9999px 9999px 0;
                  transform: rotate(-45deg);
                  position: relative;
                  box-shadow: 0 1px 3px rgba(0,0,0,0.3);
                ">
                  <div style="
                    width: 8px;
                    height: 8px;
                    background: white;
                    border-radius: 9999px;
                    position: relative;
                    top: 8px;
                    left: 8px;
                  "></div>
                </div>
              `,
              size: new window.naver.maps.Size(24, 24),
              anchor: new window.naver.maps.Point(12, 10),
            }}
          />
        ))}
      </>
    );
  }

  return null;
};
